/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as CurriculumRouteImport } from './routes/curriculum'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TournamentIndexRouteImport } from './routes/tournament/index'
import { Route as SummerIndexRouteImport } from './routes/summer/index'
import { Route as StudioIndexRouteImport } from './routes/studio/index'
import { Route as ProfileIndexRouteImport } from './routes/profile/index'
import { Route as GrandprixIndexRouteImport } from './routes/grandprix/index'
import { Route as CurriculumIndexRouteImport } from './routes/curriculum/index'
import { Route as ClubIndexRouteImport } from './routes/club/index'
import { Route as GamePairingRouteImport } from './routes/game/pairing'
import { Route as GameFriendRouteImport } from './routes/game/friend'
import { Route as GameComputerRouteImport } from './routes/game/computer'
import { Route as GameAnalysisRouteImport } from './routes/game/analysis'
import { Route as CurriculumLessonsRouteImport } from './routes/curriculum/lessons'
import { Route as CurriculumAuthorsRouteImport } from './routes/curriculum/authors'
import { Route as ClubCreateRouteImport } from './routes/club/create'
import { Route as ClubClubIdRouteImport } from './routes/club/$clubId'
import { Route as BoardsSimulatorRouteImport } from './routes/boards/simulator'
import { Route as AuthRequiredRouteImport } from './routes/auth/required'
import { Route as AuthEndRouteImport } from './routes/auth/end'
import { Route as AuthByTokenRouteImport } from './routes/auth/by-token'
import { Route as ProfileStatsIndexRouteImport } from './routes/profile/stats/index'
import { Route as ProfileClubsAndTournamentsIndexRouteImport } from './routes/profile/clubs-and-tournaments/index'
import { Route as ProfileAchievementsIndexRouteImport } from './routes/profile/achievements/index'
import { Route as ProfileUserIdIndexRouteImport } from './routes/profile/$userId/index'
import { Route as GamePairingIndexRouteImport } from './routes/game/pairing.index'
import { Route as CurriculumBooksIndexRouteImport } from './routes/curriculum/books/index'
import { Route as StudioBooksBookIdRouteImport } from './routes/studio/books/$bookId'
import { Route as ProfileStatsClockControlRouteImport } from './routes/profile/stats/$clockControl'
import { Route as GamePairingGameIdRouteImport } from './routes/game/pairing.$gameId'
import { Route as GameFriendGamesRouteImport } from './routes/game/friend_.games'
import { Route as GameFriendGameIdRouteImport } from './routes/game/friend_.$gameId'
import { Route as CurriculumBooksBookIdRouteImport } from './routes/curriculum/books/$bookId'
import { Route as ClubClubIdSettingsRouteImport } from './routes/club/$clubId_.settings'
import { Route as ClubClubIdTournamentIndexRouteImport } from './routes/club/$clubId_.tournament/index'
import { Route as GameFriendGameIdViewRouteImport } from './routes/game/friend_.$gameId_.view'
import { Route as CurriculumLessonsCourseIdLessonIdRouteImport } from './routes/curriculum/lessons_.$courseId.$lessonId'
import { Route as ClubClubIdTournamentTournamentIdRouteImport } from './routes/club/$clubId_.tournament/$tournamentId'
import { Route as ClubClubIdTournamentTournamentIdSeanceRouteImport } from './routes/club/$clubId_.tournament/$tournamentId_.seance'
import { Route as ClubClubIdTournamentTournamentIdEditRouteImport } from './routes/club/$clubId_.tournament/$tournamentId_.edit'
import { Route as ClubClubIdTournamentTournamentIdGameGameIdRouteImport } from './routes/club/$clubId_.tournament/$tournamentId_.game.$gameId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const CurriculumRoute = CurriculumRouteImport.update({
  id: '/curriculum',
  path: '/curriculum',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/curriculum.lazy').then((d) => d.Route))
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TournamentIndexRoute = TournamentIndexRouteImport.update({
  id: '/tournament/',
  path: '/tournament/',
  getParentRoute: () => rootRouteImport,
} as any)
const SummerIndexRoute = SummerIndexRouteImport.update({
  id: '/summer/',
  path: '/summer/',
  getParentRoute: () => rootRouteImport,
} as any)
const StudioIndexRoute = StudioIndexRouteImport.update({
  id: '/studio/',
  path: '/studio/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileIndexRoute = ProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => rootRouteImport,
} as any)
const GrandprixIndexRoute = GrandprixIndexRouteImport.update({
  id: '/grandprix/',
  path: '/grandprix/',
  getParentRoute: () => rootRouteImport,
} as any)
const CurriculumIndexRoute = CurriculumIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CurriculumRoute,
} as any)
const ClubIndexRoute = ClubIndexRouteImport.update({
  id: '/club/',
  path: '/club/',
  getParentRoute: () => rootRouteImport,
} as any)
const GamePairingRoute = GamePairingRouteImport.update({
  id: '/game/pairing',
  path: '/game/pairing',
  getParentRoute: () => rootRouteImport,
} as any)
const GameFriendRoute = GameFriendRouteImport.update({
  id: '/game/friend',
  path: '/game/friend',
  getParentRoute: () => rootRouteImport,
} as any)
const GameComputerRoute = GameComputerRouteImport.update({
  id: '/game/computer',
  path: '/game/computer',
  getParentRoute: () => rootRouteImport,
} as any)
const GameAnalysisRoute = GameAnalysisRouteImport.update({
  id: '/game/analysis',
  path: '/game/analysis',
  getParentRoute: () => rootRouteImport,
} as any)
const CurriculumLessonsRoute = CurriculumLessonsRouteImport.update({
  id: '/lessons',
  path: '/lessons',
  getParentRoute: () => CurriculumRoute,
} as any).lazy(() =>
  import('./routes/curriculum/lessons.lazy').then((d) => d.Route),
)
const CurriculumAuthorsRoute = CurriculumAuthorsRouteImport.update({
  id: '/authors',
  path: '/authors',
  getParentRoute: () => CurriculumRoute,
} as any).lazy(() =>
  import('./routes/curriculum/authors.lazy').then((d) => d.Route),
)
const ClubCreateRoute = ClubCreateRouteImport.update({
  id: '/club/create',
  path: '/club/create',
  getParentRoute: () => rootRouteImport,
} as any)
const ClubClubIdRoute = ClubClubIdRouteImport.update({
  id: '/club/$clubId',
  path: '/club/$clubId',
  getParentRoute: () => rootRouteImport,
} as any)
const BoardsSimulatorRoute = BoardsSimulatorRouteImport.update({
  id: '/boards/simulator',
  path: '/boards/simulator',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRequiredRoute = AuthRequiredRouteImport.update({
  id: '/auth/required',
  path: '/auth/required',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthEndRoute = AuthEndRouteImport.update({
  id: '/auth/end',
  path: '/auth/end',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthByTokenRoute = AuthByTokenRouteImport.update({
  id: '/auth/by-token',
  path: '/auth/by-token',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileStatsIndexRoute = ProfileStatsIndexRouteImport.update({
  id: '/profile/stats/',
  path: '/profile/stats/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileClubsAndTournamentsIndexRoute =
  ProfileClubsAndTournamentsIndexRouteImport.update({
    id: '/profile/clubs-and-tournaments/',
    path: '/profile/clubs-and-tournaments/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProfileAchievementsIndexRoute =
  ProfileAchievementsIndexRouteImport.update({
    id: '/profile/achievements/',
    path: '/profile/achievements/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProfileUserIdIndexRoute = ProfileUserIdIndexRouteImport.update({
  id: '/profile/$userId/',
  path: '/profile/$userId/',
  getParentRoute: () => rootRouteImport,
} as any)
const GamePairingIndexRoute = GamePairingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => GamePairingRoute,
} as any)
const CurriculumBooksIndexRoute = CurriculumBooksIndexRouteImport.update({
  id: '/books/',
  path: '/books/',
  getParentRoute: () => CurriculumRoute,
} as any).lazy(() =>
  import('./routes/curriculum/books/index.lazy').then((d) => d.Route),
)
const StudioBooksBookIdRoute = StudioBooksBookIdRouteImport.update({
  id: '/studio/books/$bookId',
  path: '/studio/books/$bookId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileStatsClockControlRoute =
  ProfileStatsClockControlRouteImport.update({
    id: '/profile/stats/$clockControl',
    path: '/profile/stats/$clockControl',
    getParentRoute: () => rootRouteImport,
  } as any)
const GamePairingGameIdRoute = GamePairingGameIdRouteImport.update({
  id: '/$gameId',
  path: '/$gameId',
  getParentRoute: () => GamePairingRoute,
} as any)
const GameFriendGamesRoute = GameFriendGamesRouteImport.update({
  id: '/game/friend_/games',
  path: '/game/friend/games',
  getParentRoute: () => rootRouteImport,
} as any)
const GameFriendGameIdRoute = GameFriendGameIdRouteImport.update({
  id: '/game/friend_/$gameId',
  path: '/game/friend/$gameId',
  getParentRoute: () => rootRouteImport,
} as any)
const CurriculumBooksBookIdRoute = CurriculumBooksBookIdRouteImport.update({
  id: '/books/$bookId',
  path: '/books/$bookId',
  getParentRoute: () => CurriculumRoute,
} as any).lazy(() =>
  import('./routes/curriculum/books/$bookId.lazy').then((d) => d.Route),
)
const ClubClubIdSettingsRoute = ClubClubIdSettingsRouteImport.update({
  id: '/club/$clubId_/settings',
  path: '/club/$clubId/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ClubClubIdTournamentIndexRoute =
  ClubClubIdTournamentIndexRouteImport.update({
    id: '/club/$clubId_/tournament/',
    path: '/club/$clubId/tournament/',
    getParentRoute: () => rootRouteImport,
  } as any)
const GameFriendGameIdViewRoute = GameFriendGameIdViewRouteImport.update({
  id: '/game/friend_/$gameId_/view',
  path: '/game/friend/$gameId/view',
  getParentRoute: () => rootRouteImport,
} as any)
const CurriculumLessonsCourseIdLessonIdRoute =
  CurriculumLessonsCourseIdLessonIdRouteImport.update({
    id: '/lessons_/$courseId/$lessonId',
    path: '/lessons/$courseId/$lessonId',
    getParentRoute: () => CurriculumRoute,
  } as any).lazy(() =>
    import('./routes/curriculum/lessons_.$courseId.$lessonId.lazy').then(
      (d) => d.Route,
    ),
  )
const ClubClubIdTournamentTournamentIdRoute =
  ClubClubIdTournamentTournamentIdRouteImport.update({
    id: '/club/$clubId_/tournament/$tournamentId',
    path: '/club/$clubId/tournament/$tournamentId',
    getParentRoute: () => rootRouteImport,
  } as any)
const ClubClubIdTournamentTournamentIdSeanceRoute =
  ClubClubIdTournamentTournamentIdSeanceRouteImport.update({
    id: '/club/$clubId_/tournament/$tournamentId_/seance',
    path: '/club/$clubId/tournament/$tournamentId/seance',
    getParentRoute: () => rootRouteImport,
  } as any)
const ClubClubIdTournamentTournamentIdEditRoute =
  ClubClubIdTournamentTournamentIdEditRouteImport.update({
    id: '/club/$clubId_/tournament/$tournamentId_/edit',
    path: '/club/$clubId/tournament/$tournamentId/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const ClubClubIdTournamentTournamentIdGameGameIdRoute =
  ClubClubIdTournamentTournamentIdGameGameIdRouteImport.update({
    id: '/club/$clubId_/tournament/$tournamentId_/game/$gameId',
    path: '/club/$clubId/tournament/$tournamentId/game/$gameId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/curriculum': typeof CurriculumRouteWithChildren
  '/login': typeof LoginRoute
  '/auth/by-token': typeof AuthByTokenRoute
  '/auth/end': typeof AuthEndRoute
  '/auth/required': typeof AuthRequiredRoute
  '/boards/simulator': typeof BoardsSimulatorRoute
  '/club/$clubId': typeof ClubClubIdRoute
  '/club/create': typeof ClubCreateRoute
  '/curriculum/authors': typeof CurriculumAuthorsRoute
  '/curriculum/lessons': typeof CurriculumLessonsRoute
  '/game/analysis': typeof GameAnalysisRoute
  '/game/computer': typeof GameComputerRoute
  '/game/friend': typeof GameFriendRoute
  '/game/pairing': typeof GamePairingRouteWithChildren
  '/club/': typeof ClubIndexRoute
  '/curriculum/': typeof CurriculumIndexRoute
  '/grandprix/': typeof GrandprixIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/studio/': typeof StudioIndexRoute
  '/summer/': typeof SummerIndexRoute
  '/tournament/': typeof TournamentIndexRoute
  '/club/$clubId/settings': typeof ClubClubIdSettingsRoute
  '/curriculum/books/$bookId': typeof CurriculumBooksBookIdRoute
  '/game/friend/$gameId': typeof GameFriendGameIdRoute
  '/game/friend/games': typeof GameFriendGamesRoute
  '/game/pairing/$gameId': typeof GamePairingGameIdRoute
  '/profile/stats/$clockControl': typeof ProfileStatsClockControlRoute
  '/studio/books/$bookId': typeof StudioBooksBookIdRoute
  '/curriculum/books/': typeof CurriculumBooksIndexRoute
  '/game/pairing/': typeof GamePairingIndexRoute
  '/profile/$userId/': typeof ProfileUserIdIndexRoute
  '/profile/achievements/': typeof ProfileAchievementsIndexRoute
  '/profile/clubs-and-tournaments/': typeof ProfileClubsAndTournamentsIndexRoute
  '/profile/stats/': typeof ProfileStatsIndexRoute
  '/club/$clubId/tournament/$tournamentId': typeof ClubClubIdTournamentTournamentIdRoute
  '/curriculum/lessons/$courseId/$lessonId': typeof CurriculumLessonsCourseIdLessonIdRoute
  '/game/friend/$gameId/view': typeof GameFriendGameIdViewRoute
  '/club/$clubId/tournament/': typeof ClubClubIdTournamentIndexRoute
  '/club/$clubId/tournament/$tournamentId/edit': typeof ClubClubIdTournamentTournamentIdEditRoute
  '/club/$clubId/tournament/$tournamentId/seance': typeof ClubClubIdTournamentTournamentIdSeanceRoute
  '/club/$clubId/tournament/$tournamentId/game/$gameId': typeof ClubClubIdTournamentTournamentIdGameGameIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/auth/by-token': typeof AuthByTokenRoute
  '/auth/end': typeof AuthEndRoute
  '/auth/required': typeof AuthRequiredRoute
  '/boards/simulator': typeof BoardsSimulatorRoute
  '/club/$clubId': typeof ClubClubIdRoute
  '/club/create': typeof ClubCreateRoute
  '/curriculum/authors': typeof CurriculumAuthorsRoute
  '/curriculum/lessons': typeof CurriculumLessonsRoute
  '/game/analysis': typeof GameAnalysisRoute
  '/game/computer': typeof GameComputerRoute
  '/game/friend': typeof GameFriendRoute
  '/club': typeof ClubIndexRoute
  '/curriculum': typeof CurriculumIndexRoute
  '/grandprix': typeof GrandprixIndexRoute
  '/profile': typeof ProfileIndexRoute
  '/studio': typeof StudioIndexRoute
  '/summer': typeof SummerIndexRoute
  '/tournament': typeof TournamentIndexRoute
  '/club/$clubId/settings': typeof ClubClubIdSettingsRoute
  '/curriculum/books/$bookId': typeof CurriculumBooksBookIdRoute
  '/game/friend/$gameId': typeof GameFriendGameIdRoute
  '/game/friend/games': typeof GameFriendGamesRoute
  '/game/pairing/$gameId': typeof GamePairingGameIdRoute
  '/profile/stats/$clockControl': typeof ProfileStatsClockControlRoute
  '/studio/books/$bookId': typeof StudioBooksBookIdRoute
  '/curriculum/books': typeof CurriculumBooksIndexRoute
  '/game/pairing': typeof GamePairingIndexRoute
  '/profile/$userId': typeof ProfileUserIdIndexRoute
  '/profile/achievements': typeof ProfileAchievementsIndexRoute
  '/profile/clubs-and-tournaments': typeof ProfileClubsAndTournamentsIndexRoute
  '/profile/stats': typeof ProfileStatsIndexRoute
  '/club/$clubId/tournament/$tournamentId': typeof ClubClubIdTournamentTournamentIdRoute
  '/curriculum/lessons/$courseId/$lessonId': typeof CurriculumLessonsCourseIdLessonIdRoute
  '/game/friend/$gameId/view': typeof GameFriendGameIdViewRoute
  '/club/$clubId/tournament': typeof ClubClubIdTournamentIndexRoute
  '/club/$clubId/tournament/$tournamentId/edit': typeof ClubClubIdTournamentTournamentIdEditRoute
  '/club/$clubId/tournament/$tournamentId/seance': typeof ClubClubIdTournamentTournamentIdSeanceRoute
  '/club/$clubId/tournament/$tournamentId/game/$gameId': typeof ClubClubIdTournamentTournamentIdGameGameIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/curriculum': typeof CurriculumRouteWithChildren
  '/login': typeof LoginRoute
  '/auth/by-token': typeof AuthByTokenRoute
  '/auth/end': typeof AuthEndRoute
  '/auth/required': typeof AuthRequiredRoute
  '/boards/simulator': typeof BoardsSimulatorRoute
  '/club/$clubId': typeof ClubClubIdRoute
  '/club/create': typeof ClubCreateRoute
  '/curriculum/authors': typeof CurriculumAuthorsRoute
  '/curriculum/lessons': typeof CurriculumLessonsRoute
  '/game/analysis': typeof GameAnalysisRoute
  '/game/computer': typeof GameComputerRoute
  '/game/friend': typeof GameFriendRoute
  '/game/pairing': typeof GamePairingRouteWithChildren
  '/club/': typeof ClubIndexRoute
  '/curriculum/': typeof CurriculumIndexRoute
  '/grandprix/': typeof GrandprixIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/studio/': typeof StudioIndexRoute
  '/summer/': typeof SummerIndexRoute
  '/tournament/': typeof TournamentIndexRoute
  '/club/$clubId_/settings': typeof ClubClubIdSettingsRoute
  '/curriculum/books/$bookId': typeof CurriculumBooksBookIdRoute
  '/game/friend_/$gameId': typeof GameFriendGameIdRoute
  '/game/friend_/games': typeof GameFriendGamesRoute
  '/game/pairing/$gameId': typeof GamePairingGameIdRoute
  '/profile/stats/$clockControl': typeof ProfileStatsClockControlRoute
  '/studio/books/$bookId': typeof StudioBooksBookIdRoute
  '/curriculum/books/': typeof CurriculumBooksIndexRoute
  '/game/pairing/': typeof GamePairingIndexRoute
  '/profile/$userId/': typeof ProfileUserIdIndexRoute
  '/profile/achievements/': typeof ProfileAchievementsIndexRoute
  '/profile/clubs-and-tournaments/': typeof ProfileClubsAndTournamentsIndexRoute
  '/profile/stats/': typeof ProfileStatsIndexRoute
  '/club/$clubId_/tournament/$tournamentId': typeof ClubClubIdTournamentTournamentIdRoute
  '/curriculum/lessons_/$courseId/$lessonId': typeof CurriculumLessonsCourseIdLessonIdRoute
  '/game/friend_/$gameId_/view': typeof GameFriendGameIdViewRoute
  '/club/$clubId_/tournament/': typeof ClubClubIdTournamentIndexRoute
  '/club/$clubId_/tournament/$tournamentId_/edit': typeof ClubClubIdTournamentTournamentIdEditRoute
  '/club/$clubId_/tournament/$tournamentId_/seance': typeof ClubClubIdTournamentTournamentIdSeanceRoute
  '/club/$clubId_/tournament/$tournamentId_/game/$gameId': typeof ClubClubIdTournamentTournamentIdGameGameIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/curriculum'
    | '/login'
    | '/auth/by-token'
    | '/auth/end'
    | '/auth/required'
    | '/boards/simulator'
    | '/club/$clubId'
    | '/club/create'
    | '/curriculum/authors'
    | '/curriculum/lessons'
    | '/game/analysis'
    | '/game/computer'
    | '/game/friend'
    | '/game/pairing'
    | '/club/'
    | '/curriculum/'
    | '/grandprix/'
    | '/profile/'
    | '/studio/'
    | '/summer/'
    | '/tournament/'
    | '/club/$clubId/settings'
    | '/curriculum/books/$bookId'
    | '/game/friend/$gameId'
    | '/game/friend/games'
    | '/game/pairing/$gameId'
    | '/profile/stats/$clockControl'
    | '/studio/books/$bookId'
    | '/curriculum/books/'
    | '/game/pairing/'
    | '/profile/$userId/'
    | '/profile/achievements/'
    | '/profile/clubs-and-tournaments/'
    | '/profile/stats/'
    | '/club/$clubId/tournament/$tournamentId'
    | '/curriculum/lessons/$courseId/$lessonId'
    | '/game/friend/$gameId/view'
    | '/club/$clubId/tournament/'
    | '/club/$clubId/tournament/$tournamentId/edit'
    | '/club/$clubId/tournament/$tournamentId/seance'
    | '/club/$clubId/tournament/$tournamentId/game/$gameId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/auth/by-token'
    | '/auth/end'
    | '/auth/required'
    | '/boards/simulator'
    | '/club/$clubId'
    | '/club/create'
    | '/curriculum/authors'
    | '/curriculum/lessons'
    | '/game/analysis'
    | '/game/computer'
    | '/game/friend'
    | '/club'
    | '/curriculum'
    | '/grandprix'
    | '/profile'
    | '/studio'
    | '/summer'
    | '/tournament'
    | '/club/$clubId/settings'
    | '/curriculum/books/$bookId'
    | '/game/friend/$gameId'
    | '/game/friend/games'
    | '/game/pairing/$gameId'
    | '/profile/stats/$clockControl'
    | '/studio/books/$bookId'
    | '/curriculum/books'
    | '/game/pairing'
    | '/profile/$userId'
    | '/profile/achievements'
    | '/profile/clubs-and-tournaments'
    | '/profile/stats'
    | '/club/$clubId/tournament/$tournamentId'
    | '/curriculum/lessons/$courseId/$lessonId'
    | '/game/friend/$gameId/view'
    | '/club/$clubId/tournament'
    | '/club/$clubId/tournament/$tournamentId/edit'
    | '/club/$clubId/tournament/$tournamentId/seance'
    | '/club/$clubId/tournament/$tournamentId/game/$gameId'
  id:
    | '__root__'
    | '/'
    | '/curriculum'
    | '/login'
    | '/auth/by-token'
    | '/auth/end'
    | '/auth/required'
    | '/boards/simulator'
    | '/club/$clubId'
    | '/club/create'
    | '/curriculum/authors'
    | '/curriculum/lessons'
    | '/game/analysis'
    | '/game/computer'
    | '/game/friend'
    | '/game/pairing'
    | '/club/'
    | '/curriculum/'
    | '/grandprix/'
    | '/profile/'
    | '/studio/'
    | '/summer/'
    | '/tournament/'
    | '/club/$clubId_/settings'
    | '/curriculum/books/$bookId'
    | '/game/friend_/$gameId'
    | '/game/friend_/games'
    | '/game/pairing/$gameId'
    | '/profile/stats/$clockControl'
    | '/studio/books/$bookId'
    | '/curriculum/books/'
    | '/game/pairing/'
    | '/profile/$userId/'
    | '/profile/achievements/'
    | '/profile/clubs-and-tournaments/'
    | '/profile/stats/'
    | '/club/$clubId_/tournament/$tournamentId'
    | '/curriculum/lessons_/$courseId/$lessonId'
    | '/game/friend_/$gameId_/view'
    | '/club/$clubId_/tournament/'
    | '/club/$clubId_/tournament/$tournamentId_/edit'
    | '/club/$clubId_/tournament/$tournamentId_/seance'
    | '/club/$clubId_/tournament/$tournamentId_/game/$gameId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CurriculumRoute: typeof CurriculumRouteWithChildren
  LoginRoute: typeof LoginRoute
  AuthByTokenRoute: typeof AuthByTokenRoute
  AuthEndRoute: typeof AuthEndRoute
  AuthRequiredRoute: typeof AuthRequiredRoute
  BoardsSimulatorRoute: typeof BoardsSimulatorRoute
  ClubClubIdRoute: typeof ClubClubIdRoute
  ClubCreateRoute: typeof ClubCreateRoute
  GameAnalysisRoute: typeof GameAnalysisRoute
  GameComputerRoute: typeof GameComputerRoute
  GameFriendRoute: typeof GameFriendRoute
  GamePairingRoute: typeof GamePairingRouteWithChildren
  ClubIndexRoute: typeof ClubIndexRoute
  GrandprixIndexRoute: typeof GrandprixIndexRoute
  ProfileIndexRoute: typeof ProfileIndexRoute
  StudioIndexRoute: typeof StudioIndexRoute
  SummerIndexRoute: typeof SummerIndexRoute
  TournamentIndexRoute: typeof TournamentIndexRoute
  ClubClubIdSettingsRoute: typeof ClubClubIdSettingsRoute
  GameFriendGameIdRoute: typeof GameFriendGameIdRoute
  GameFriendGamesRoute: typeof GameFriendGamesRoute
  ProfileStatsClockControlRoute: typeof ProfileStatsClockControlRoute
  StudioBooksBookIdRoute: typeof StudioBooksBookIdRoute
  ProfileUserIdIndexRoute: typeof ProfileUserIdIndexRoute
  ProfileAchievementsIndexRoute: typeof ProfileAchievementsIndexRoute
  ProfileClubsAndTournamentsIndexRoute: typeof ProfileClubsAndTournamentsIndexRoute
  ProfileStatsIndexRoute: typeof ProfileStatsIndexRoute
  ClubClubIdTournamentTournamentIdRoute: typeof ClubClubIdTournamentTournamentIdRoute
  GameFriendGameIdViewRoute: typeof GameFriendGameIdViewRoute
  ClubClubIdTournamentIndexRoute: typeof ClubClubIdTournamentIndexRoute
  ClubClubIdTournamentTournamentIdEditRoute: typeof ClubClubIdTournamentTournamentIdEditRoute
  ClubClubIdTournamentTournamentIdSeanceRoute: typeof ClubClubIdTournamentTournamentIdSeanceRoute
  ClubClubIdTournamentTournamentIdGameGameIdRoute: typeof ClubClubIdTournamentTournamentIdGameGameIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/curriculum': {
      id: '/curriculum'
      path: '/curriculum'
      fullPath: '/curriculum'
      preLoaderRoute: typeof CurriculumRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tournament/': {
      id: '/tournament/'
      path: '/tournament'
      fullPath: '/tournament/'
      preLoaderRoute: typeof TournamentIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/summer/': {
      id: '/summer/'
      path: '/summer'
      fullPath: '/summer/'
      preLoaderRoute: typeof SummerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/studio/': {
      id: '/studio/'
      path: '/studio'
      fullPath: '/studio/'
      preLoaderRoute: typeof StudioIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/': {
      id: '/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof ProfileIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/grandprix/': {
      id: '/grandprix/'
      path: '/grandprix'
      fullPath: '/grandprix/'
      preLoaderRoute: typeof GrandprixIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/curriculum/': {
      id: '/curriculum/'
      path: '/'
      fullPath: '/curriculum/'
      preLoaderRoute: typeof CurriculumIndexRouteImport
      parentRoute: typeof CurriculumRoute
    }
    '/club/': {
      id: '/club/'
      path: '/club'
      fullPath: '/club/'
      preLoaderRoute: typeof ClubIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/game/pairing': {
      id: '/game/pairing'
      path: '/game/pairing'
      fullPath: '/game/pairing'
      preLoaderRoute: typeof GamePairingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/game/friend': {
      id: '/game/friend'
      path: '/game/friend'
      fullPath: '/game/friend'
      preLoaderRoute: typeof GameFriendRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/game/computer': {
      id: '/game/computer'
      path: '/game/computer'
      fullPath: '/game/computer'
      preLoaderRoute: typeof GameComputerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/game/analysis': {
      id: '/game/analysis'
      path: '/game/analysis'
      fullPath: '/game/analysis'
      preLoaderRoute: typeof GameAnalysisRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/curriculum/lessons': {
      id: '/curriculum/lessons'
      path: '/lessons'
      fullPath: '/curriculum/lessons'
      preLoaderRoute: typeof CurriculumLessonsRouteImport
      parentRoute: typeof CurriculumRoute
    }
    '/curriculum/authors': {
      id: '/curriculum/authors'
      path: '/authors'
      fullPath: '/curriculum/authors'
      preLoaderRoute: typeof CurriculumAuthorsRouteImport
      parentRoute: typeof CurriculumRoute
    }
    '/club/create': {
      id: '/club/create'
      path: '/club/create'
      fullPath: '/club/create'
      preLoaderRoute: typeof ClubCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/club/$clubId': {
      id: '/club/$clubId'
      path: '/club/$clubId'
      fullPath: '/club/$clubId'
      preLoaderRoute: typeof ClubClubIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/boards/simulator': {
      id: '/boards/simulator'
      path: '/boards/simulator'
      fullPath: '/boards/simulator'
      preLoaderRoute: typeof BoardsSimulatorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/required': {
      id: '/auth/required'
      path: '/auth/required'
      fullPath: '/auth/required'
      preLoaderRoute: typeof AuthRequiredRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/end': {
      id: '/auth/end'
      path: '/auth/end'
      fullPath: '/auth/end'
      preLoaderRoute: typeof AuthEndRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/by-token': {
      id: '/auth/by-token'
      path: '/auth/by-token'
      fullPath: '/auth/by-token'
      preLoaderRoute: typeof AuthByTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/stats/': {
      id: '/profile/stats/'
      path: '/profile/stats'
      fullPath: '/profile/stats/'
      preLoaderRoute: typeof ProfileStatsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/clubs-and-tournaments/': {
      id: '/profile/clubs-and-tournaments/'
      path: '/profile/clubs-and-tournaments'
      fullPath: '/profile/clubs-and-tournaments/'
      preLoaderRoute: typeof ProfileClubsAndTournamentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/achievements/': {
      id: '/profile/achievements/'
      path: '/profile/achievements'
      fullPath: '/profile/achievements/'
      preLoaderRoute: typeof ProfileAchievementsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/$userId/': {
      id: '/profile/$userId/'
      path: '/profile/$userId'
      fullPath: '/profile/$userId/'
      preLoaderRoute: typeof ProfileUserIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/game/pairing/': {
      id: '/game/pairing/'
      path: '/'
      fullPath: '/game/pairing/'
      preLoaderRoute: typeof GamePairingIndexRouteImport
      parentRoute: typeof GamePairingRoute
    }
    '/curriculum/books/': {
      id: '/curriculum/books/'
      path: '/books'
      fullPath: '/curriculum/books/'
      preLoaderRoute: typeof CurriculumBooksIndexRouteImport
      parentRoute: typeof CurriculumRoute
    }
    '/studio/books/$bookId': {
      id: '/studio/books/$bookId'
      path: '/studio/books/$bookId'
      fullPath: '/studio/books/$bookId'
      preLoaderRoute: typeof StudioBooksBookIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/stats/$clockControl': {
      id: '/profile/stats/$clockControl'
      path: '/profile/stats/$clockControl'
      fullPath: '/profile/stats/$clockControl'
      preLoaderRoute: typeof ProfileStatsClockControlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/game/pairing/$gameId': {
      id: '/game/pairing/$gameId'
      path: '/$gameId'
      fullPath: '/game/pairing/$gameId'
      preLoaderRoute: typeof GamePairingGameIdRouteImport
      parentRoute: typeof GamePairingRoute
    }
    '/game/friend_/games': {
      id: '/game/friend_/games'
      path: '/game/friend/games'
      fullPath: '/game/friend/games'
      preLoaderRoute: typeof GameFriendGamesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/game/friend_/$gameId': {
      id: '/game/friend_/$gameId'
      path: '/game/friend/$gameId'
      fullPath: '/game/friend/$gameId'
      preLoaderRoute: typeof GameFriendGameIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/curriculum/books/$bookId': {
      id: '/curriculum/books/$bookId'
      path: '/books/$bookId'
      fullPath: '/curriculum/books/$bookId'
      preLoaderRoute: typeof CurriculumBooksBookIdRouteImport
      parentRoute: typeof CurriculumRoute
    }
    '/club/$clubId_/settings': {
      id: '/club/$clubId_/settings'
      path: '/club/$clubId/settings'
      fullPath: '/club/$clubId/settings'
      preLoaderRoute: typeof ClubClubIdSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/club/$clubId_/tournament/': {
      id: '/club/$clubId_/tournament/'
      path: '/club/$clubId/tournament'
      fullPath: '/club/$clubId/tournament/'
      preLoaderRoute: typeof ClubClubIdTournamentIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/game/friend_/$gameId_/view': {
      id: '/game/friend_/$gameId_/view'
      path: '/game/friend/$gameId/view'
      fullPath: '/game/friend/$gameId/view'
      preLoaderRoute: typeof GameFriendGameIdViewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/curriculum/lessons_/$courseId/$lessonId': {
      id: '/curriculum/lessons_/$courseId/$lessonId'
      path: '/lessons/$courseId/$lessonId'
      fullPath: '/curriculum/lessons/$courseId/$lessonId'
      preLoaderRoute: typeof CurriculumLessonsCourseIdLessonIdRouteImport
      parentRoute: typeof CurriculumRoute
    }
    '/club/$clubId_/tournament/$tournamentId': {
      id: '/club/$clubId_/tournament/$tournamentId'
      path: '/club/$clubId/tournament/$tournamentId'
      fullPath: '/club/$clubId/tournament/$tournamentId'
      preLoaderRoute: typeof ClubClubIdTournamentTournamentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/club/$clubId_/tournament/$tournamentId_/seance': {
      id: '/club/$clubId_/tournament/$tournamentId_/seance'
      path: '/club/$clubId/tournament/$tournamentId/seance'
      fullPath: '/club/$clubId/tournament/$tournamentId/seance'
      preLoaderRoute: typeof ClubClubIdTournamentTournamentIdSeanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/club/$clubId_/tournament/$tournamentId_/edit': {
      id: '/club/$clubId_/tournament/$tournamentId_/edit'
      path: '/club/$clubId/tournament/$tournamentId/edit'
      fullPath: '/club/$clubId/tournament/$tournamentId/edit'
      preLoaderRoute: typeof ClubClubIdTournamentTournamentIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/club/$clubId_/tournament/$tournamentId_/game/$gameId': {
      id: '/club/$clubId_/tournament/$tournamentId_/game/$gameId'
      path: '/club/$clubId/tournament/$tournamentId/game/$gameId'
      fullPath: '/club/$clubId/tournament/$tournamentId/game/$gameId'
      preLoaderRoute: typeof ClubClubIdTournamentTournamentIdGameGameIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface CurriculumRouteChildren {
  CurriculumAuthorsRoute: typeof CurriculumAuthorsRoute
  CurriculumLessonsRoute: typeof CurriculumLessonsRoute
  CurriculumIndexRoute: typeof CurriculumIndexRoute
  CurriculumBooksBookIdRoute: typeof CurriculumBooksBookIdRoute
  CurriculumBooksIndexRoute: typeof CurriculumBooksIndexRoute
  CurriculumLessonsCourseIdLessonIdRoute: typeof CurriculumLessonsCourseIdLessonIdRoute
}

const CurriculumRouteChildren: CurriculumRouteChildren = {
  CurriculumAuthorsRoute: CurriculumAuthorsRoute,
  CurriculumLessonsRoute: CurriculumLessonsRoute,
  CurriculumIndexRoute: CurriculumIndexRoute,
  CurriculumBooksBookIdRoute: CurriculumBooksBookIdRoute,
  CurriculumBooksIndexRoute: CurriculumBooksIndexRoute,
  CurriculumLessonsCourseIdLessonIdRoute:
    CurriculumLessonsCourseIdLessonIdRoute,
}

const CurriculumRouteWithChildren = CurriculumRoute._addFileChildren(
  CurriculumRouteChildren,
)

interface GamePairingRouteChildren {
  GamePairingGameIdRoute: typeof GamePairingGameIdRoute
  GamePairingIndexRoute: typeof GamePairingIndexRoute
}

const GamePairingRouteChildren: GamePairingRouteChildren = {
  GamePairingGameIdRoute: GamePairingGameIdRoute,
  GamePairingIndexRoute: GamePairingIndexRoute,
}

const GamePairingRouteWithChildren = GamePairingRoute._addFileChildren(
  GamePairingRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CurriculumRoute: CurriculumRouteWithChildren,
  LoginRoute: LoginRoute,
  AuthByTokenRoute: AuthByTokenRoute,
  AuthEndRoute: AuthEndRoute,
  AuthRequiredRoute: AuthRequiredRoute,
  BoardsSimulatorRoute: BoardsSimulatorRoute,
  ClubClubIdRoute: ClubClubIdRoute,
  ClubCreateRoute: ClubCreateRoute,
  GameAnalysisRoute: GameAnalysisRoute,
  GameComputerRoute: GameComputerRoute,
  GameFriendRoute: GameFriendRoute,
  GamePairingRoute: GamePairingRouteWithChildren,
  ClubIndexRoute: ClubIndexRoute,
  GrandprixIndexRoute: GrandprixIndexRoute,
  ProfileIndexRoute: ProfileIndexRoute,
  StudioIndexRoute: StudioIndexRoute,
  SummerIndexRoute: SummerIndexRoute,
  TournamentIndexRoute: TournamentIndexRoute,
  ClubClubIdSettingsRoute: ClubClubIdSettingsRoute,
  GameFriendGameIdRoute: GameFriendGameIdRoute,
  GameFriendGamesRoute: GameFriendGamesRoute,
  ProfileStatsClockControlRoute: ProfileStatsClockControlRoute,
  StudioBooksBookIdRoute: StudioBooksBookIdRoute,
  ProfileUserIdIndexRoute: ProfileUserIdIndexRoute,
  ProfileAchievementsIndexRoute: ProfileAchievementsIndexRoute,
  ProfileClubsAndTournamentsIndexRoute: ProfileClubsAndTournamentsIndexRoute,
  ProfileStatsIndexRoute: ProfileStatsIndexRoute,
  ClubClubIdTournamentTournamentIdRoute: ClubClubIdTournamentTournamentIdRoute,
  GameFriendGameIdViewRoute: GameFriendGameIdViewRoute,
  ClubClubIdTournamentIndexRoute: ClubClubIdTournamentIndexRoute,
  ClubClubIdTournamentTournamentIdEditRoute:
    ClubClubIdTournamentTournamentIdEditRoute,
  ClubClubIdTournamentTournamentIdSeanceRoute:
    ClubClubIdTournamentTournamentIdSeanceRoute,
  ClubClubIdTournamentTournamentIdGameGameIdRoute:
    ClubClubIdTournamentTournamentIdGameGameIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
